<template>
  <div class="wrapper">
    <notifications></notifications>

    <!-- Side Bar -->
    <side-bar>
      <template slot-scope="props" slot="links">

        <!-- Home -->
        <sidebar-item :link="{ name: 'Principal', path: { name: 'Dashboard' }, icon: 'fas fa-home text-primary'}"></sidebar-item>

        <!-- Videos -->
        <sidebar-item v-if="hasAccess" :link="{ name: 'Clases', icon: 'fas fa-play-circle text-primary'}">

          <!-- Todos -->
          <sidebar-item :link="{ name: 'Todas', path: { name: 'Videos', params: { cat: 'all'} } }"></sidebar-item>

          <!-- Categorías -->
          <div v-for="(category, index) in videoCategories" :key="index" >
            <sidebar-item :link="{ name: category.label, path: { name: 'Videos', params: { cat: category.value } } }"></sidebar-item>
          </div>

          <!-- Pink Workout -->
          <!-- <sidebar-item :link="{ name: 'Pink Workout', path: { name: 'Videos', params: { cat: 'pinkworkout'} } }"></sidebar-item> -->

          <!-- Booty Fit -->
          <!-- <sidebar-item :link="{ name: 'Booty Fit', path: { name: 'Videos', params: { cat: 'bootyfit'} } }"></sidebar-item> -->

          <!-- Dance Fit -->
          <!-- <sidebar-item :link="{ name: 'Dance Fit', path: { name: 'Videos', params: { cat: 'dancefit'} } }"></sidebar-item> -->

        </sidebar-item>

        <!-- Documents -->
        <sidebar-item v-if="hasAccess" :link="{ name: 'Documentos', icon: 'fas fa-file-alt text-primary'}">

          <!-- Todas -->
          <sidebar-item :link="{ name: 'Todos', path: { name: 'Documents', params: { cat: 'all'} } }"></sidebar-item>

          <!-- Categorías -->
          <div v-for="(category, index) in documentCategories" :key="index" >
            <sidebar-item :link="{ name: category.label, path: { name: 'Documents', params: { cat: category.value } } }"></sidebar-item>
          </div>

        </sidebar-item>
        
        <!-- Users -->
        <sidebar-item v-if="isAdmin" :link="{ name:'Usuarias', path: { name:'Users' }, icon: 'fas fa-users text-primary' }"></sidebar-item>

        <!-- Content Management -->
        <sidebar-item v-if="isAdmin" :link="{ name: 'Contenido', icon: 'fas fa-folder-open text-primary' }">

          <!-- Videos -->
          <sidebar-item :link="{ name: 'Videos', path: { name: 'VideoManagement'} }"></sidebar-item>

          <!-- Documents -->
          <sidebar-item :link="{ name: 'Documentos', path: { name: 'DocumentsManagement'} }"></sidebar-item>

        </sidebar-item>

        <!-- Global Config -->
        <sidebar-item v-if="isAdmin" :link="{ name: 'Configuración', path: { name: 'GlobalConfig'}, icon: 'fas fa-cog text-primary' }"></sidebar-item>

        <!-- Profile -->
        <sidebar-item v-if="user.id" :link="{ name: 'Mi Perfil', path: { name: 'Profile', params: { user_id: user.id } }, icon: 'fas fa-user-circle text-primary' }"></sidebar-item>
        
      </template>
    </side-bar>

    <!-- Main Content -->
    <div class="main-content">
      <dashboard-navbar :user="user"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <!-- <div>{{ videoConfig }}</div> -->
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './Navbar.vue';
import ContentFooter from './Footer.vue';
import DashboardContent from '../Layout/Content.vue';
import { FadeTransition } from 'vue2-transitions';
import firebase from 'firebase/app'
import 'firebase/auth'
import { mainStorage } from '@/store/main.js'

export default {
  data() {
    return {
      user: mainStorage.state.user,
      videoCategories: mainStorage.state.categoryOptions,
      documentCategories: mainStorage.state.documentCategoryOptions
    }
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  computed: {
    isAdmin() {
      return this.user.userType === "admin"
    },
    hasAccess() {
      return this.user.userType === "admin" || this.user.loginType === "coach" || this.user.hasPaidAccess || this.user.hasManualAccess
    }
  },
  methods: {
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('scrollbar-inner');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  created() {

    // Get the video config
    mainStorage.fetchVideoConfig()
    // Get the documents config
    mainStorage.fetchDocumentConfig()
    // Get the payments config
    mainStorage.fetchPaymentConfig()

    // Set up an observer that will check for changes in the login state
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        
        // Get the user from Firestore
        mainStorage.fetchFirestoreUser(user.uid)

      } else {
        this.$router.go()
      }
    })
  }
};
</script>

<style>
.navbar-inner .router-link-exact-active {
  /* border-left: solid 1px var(--primary); */
  background: rgb(255, 237, 245);
  transition: 0.5s;
}

</style>
